export class AppConfigurationError extends Error {
  constructor(message = 'Application improperly configured.') {
    super();

    this.message = message;
    this.name = 'AppConfigurationError';
  }
}
